// extracted by mini-css-extract-plugin
module.exports = {"figure":"Figure3--figure--3PK6G","background":"Figure3--background--XOzMX"};